export default __webpack_public_path__ + "e481491ed6344de5194039ae05ca4ade.svg";